import './About.css'

function About() {
    return (
        <div className='contact-card'>
            <div className='abt-container'>
                <p className='detail-card-title'>Acerca de Nosotros</p>
                <p className='detail-card-subtitle'>
                    Nos especializamos en la creación y ejecución de proyectos arquitectónicos, de diseño y construcción, siempre con el compromiso de transformar tus ideas en espacios funcionales, innovadores y sostenibles. Con más de 15 años de experiencia en el sector, contamos con un equipo multidisciplinario que incluye arquitectos, constructores civiles y contratistas especializados, lo que nos permite ofrecer soluciones integrales para cada necesidad.
                </p>
                <p className='detail-card-subtitle'>
                    Nuestros servicios abarcan una amplia gama de áreas, desde proyectos habitacionales, comerciales e industriales, hasta la fabricación de muebles a medida, diseño de cocinas, construcción de quinchos y piscinas, y remodelaciones de todo tipo. Nos enorgullece la atención al detalle y la calidad en cada uno de nuestros proyectos, asegurando que cada espacio cumpla con los más altos estándares de diseño, funcionalidad y durabilidad.
                </p>
                <p className='detail-card-subtitle'>
                Entendemos que cada proyecto es único, por eso trabajamos de cerca con nuestros clientes para adaptar cada diseño a sus necesidades y visión. Ya sea que busques una construcción desde cero, una remodelación o el diseño de un espacio personalizado, estamos aquí para hacerlo realidad.
                </p>
                <p className='detail-card-subtitle'>
                    Tu proyecto, nuestra pasión.
                </p>
            </div>
        </div>
    )
}

export default About